module.exports = __webpack_public_path__ + "static/media/(V)_MG_5426_-_Pro-Natura_-_Moda_Feminina.e286af40.jpg";